import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';
import { PageNotFoundPageModule } from '@app/modules/page-not-found-page/page-not-found-page.module';
import { PageNotFoundPageComponent } from './modules/page-not-found-page/page-not-found-page.component';

export const AppRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('@app/layouts/main/main.module').then((m) => m.MainModule),
  },
  {
    path: 'home',
    loadChildren: () => import('@app/modules/home-page/home-page.module').then((m) => m.HomePageModule),
  },
  {
    path: 'external',
    loadChildren: () => import('./modules/external/external.module').then((m) => m.ExternalModule),
  },
  {
    path: '404',
    component: PageNotFoundPageComponent,
  },
  { path: '**', redirectTo: '/404' },
];

@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(AppRoutes, {
    // initialNavigation: 'enabled',
    paramsInheritanceStrategy: 'always',
    scrollPositionRestoration: 'enabled'
}),
    PageNotFoundPageModule,
  ],
})
export class AppRoutingModule {}
